import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { useRequestListagem } from './useRequestListagem';

import { useApplicationContext } from 'context/ApplicationContext';

export interface TicketModelProps {
    dsUrlHelpDesk: string;
    dsDataHelpDesk: {
        desk_login: string;
        desk_senha: string;
        desk_prefixo: string;
    };
    dsTipoHelpDesk: string;
}

/**
 * Abre o DeskManager enviando os dados necessários para autenticação.
 */
const open = (data: TicketModelProps) => {
    const form: HTMLFormElement = document.createElement('form');

    form.setAttribute('action', data.dsUrlHelpDesk);
    form.setAttribute('method', 'post');
    form.setAttribute('target', '_blank');

    const prefixo: HTMLInputElement = document.createElement('input');
    prefixo.setAttribute('name', 'desk_prefixo');
    prefixo.setAttribute('value', data.dsDataHelpDesk.desk_prefixo);

    const senha: HTMLInputElement = document.createElement('input');
    senha.setAttribute('name', 'desk_senha');
    senha.setAttribute('value', data.dsDataHelpDesk.desk_senha);

    const email: HTMLInputElement = document.createElement('input');
    email.setAttribute('name', 'desk_login');
    email.setAttribute('value', data.dsDataHelpDesk.desk_login);

    document.body.appendChild(form);

    form.appendChild(prefixo);
    form.appendChild(senha);
    form.appendChild(email);

    form.submit();

    form.removeChild(prefixo);
    form.removeChild(senha);
    form.removeChild(email);

    document.body.removeChild(form);
};

export const useQueryDeskManager = () => {
    const requestListagem = useRequestListagem();

    return useQuery({
        queryKey: ['suporte'],
        queryFn: () =>
            requestListagem({
                url: '/config/configgeral/helpdesk',
                columns: 'dsUrlHelpDesk,dsDataHelpDesk,desk_prefixo,desk_senha,desk_login',
            }).then((res) => res.data),
    });
};

export const useDeskManager = () => {
    const { store } = useApplicationContext();
    const { data, isFetching } = useQueryDeskManager();

    /**
     * Abre o DeskManager enviando os dados necessários para autenticação.
     */
    const openDeskManager = () => {
        if (data && data.dsTipoHelpDesk === 'desk.ms') {
            if (!store.dsEmail) {
                enqueueSnackbar('E-mail da loja não configurado', { variant: 'error' });

                return;
            }

            data.dsDataHelpDesk.desk_login = store.dsEmail;

            open(data);
        }
    };

    return { openDeskManager, isFetching };
};
